import { SkillType } from "../model/skills";
import { EntityId } from "../types";

export type PlayerPreset = {
  items: {
    item: EntityId;
    quality: number;
    stack: number;
    equip: boolean;
    hotbar: number;
  }[];
  skills: Partial<Record<SkillType, number>>;
};

export const itemSets: Record<string, PlayerPreset> = {
  Meadows: {
    items: [
      { item: 'ShieldWood', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldWoodTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Bow', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmoredRagsChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmoredRagsLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'Honey', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Raspberry', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'CookedDeerMeat', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'CookedDeer', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'Mushroom', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowWood', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'AxeStone', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeBronze', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearFlint', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'KnifeFlint', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'Club', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: {
      [SkillType.Swords]: 1,
      [SkillType.Axes]: 1,
      [SkillType.Bows]: 1,
      [SkillType.Jump]: 1,
      [SkillType.Run]: 1,
      [SkillType.Blocking]: 1,
      [SkillType.Sneak]: 1,
      [SkillType.Swim]: 1,
      [SkillType.Spears]: 1,
      [SkillType.Pickaxes]: 1,
      [SkillType.WoodCutting]: 1,
      [SkillType.Knives]: 1,
      [SkillType.Clubs]: 1,
      [SkillType.Unarmed]: 1,
    }
  },
  BlackForest: {
    items: [
      { item: 'ShieldWood', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldBoneTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Bow', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorLeatherChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorLeatherLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetLeather', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeDeerHide', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'Honey', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Raspberry', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'CookedDeerMeat', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'CookedDeer', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'Mushroom', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowFlint', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'AxeFlint', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeAntler', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearFlint', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'KnifeFlint', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'Club', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: {
      [SkillType.Swords]: 10,
      [SkillType.Axes]: 10,
      [SkillType.Bows]: 10,
      [SkillType.Jump]: 10,
      [SkillType.Run]: 10,
      [SkillType.Blocking]: 10,
      [SkillType.Sneak]: 10,
      [SkillType.Swim]: 10,
      [SkillType.Spears]: 10,
      [SkillType.Pickaxes]: 10,
      [SkillType.WoodCutting]: 10,
      [SkillType.Knives]: 10,
      [SkillType.Clubs]: 10,
      [SkillType.Unarmed]: 10,
    }
  },
  Swamps: {
    items: [
      { item: 'SwordBronze', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'ShieldBronzeBuckler', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldBoneTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'BowFineWood', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorBronzeChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorBronzeLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetBronze', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeTrollHide', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CarrotSoup', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'DeerStew', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'BoarJerky', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'QueensJam', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'MinceMeatSauce', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'MeadPoisonResist', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowBronze', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'ArmorTrollLeatherChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorTrollLeatherLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetTrollLeather', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'AxeBronze', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeBronze', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearBronze', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'AtgeirBronze', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'MaceBronze', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: {
      [SkillType.Swords]: 15,
      [SkillType.Axes]: 15,
      [SkillType.Bows]: 15,
      [SkillType.Jump]: 15,
      [SkillType.Run]: 15,
      [SkillType.Blocking]: 10,
      [SkillType.Sneak]: 10,
      [SkillType.Swim]: 5,
      [SkillType.Spears]: 15,
      [SkillType.Pickaxes]: 10,
      [SkillType.WoodCutting]: 20,
      [SkillType.Polearms]: 15,
      [SkillType.Knives]: 15,
      [SkillType.Clubs]: 15,
      [SkillType.Unarmed]: 15,
    }
  },
  Mountains: {
    items: [
      { item: 'SwordIron', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'ShieldIronBuckler', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldBandedTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldIronTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'BowHuntsman', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorIronChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorIronLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetIron', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetRoot', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorRootChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorRootLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeTrollHide', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'TurnipStew', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'ShocklateSmoothie', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'BlackSoup', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadFrostResist', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'Sausages', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowIron', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'AxeIron', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeIron', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearElderbark', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'AtgeirIron', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'MaceIron', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'KnifeChitin', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: {
      [SkillType.Swords]: 25,
      [SkillType.Axes]: 25,
      [SkillType.Bows]: 25,
      [SkillType.Jump]: 25,
      [SkillType.Run]: 25,
      [SkillType.Blocking]: 25,
      [SkillType.Sneak]: 25,
      [SkillType.Swim]: 25,
      [SkillType.Spears]: 25,
      [SkillType.Pickaxes]: 25,
      [SkillType.WoodCutting]: 25,
      [SkillType.Knives]: 25,
      [SkillType.Polearms]: 25,
      [SkillType.Clubs]: 25,
      [SkillType.Unarmed]: 25,
    }
  },
  Plains: {
    items: [
      { item: 'SwordSilver', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'ShieldSilver', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldSerpentscale', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'BowDraugrFang', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorWolfChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorWolfLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetDrake', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeWolf', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'WolfMeatSkewer', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'WolfJerky', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Eyescream', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'OnionSoup', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'CookedWolfMeat', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowObsidian', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'BattleaxeCrystal', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeIron', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearWolfFang', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'SledgeIron', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'MaceSilver', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'KnifeSilver', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'FistFenrirClaw', quality: 1, stack: 1, equip: true, hotbar: 7 },
      { item: 'ArmorFenringChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorFenringLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetFenring', quality: 1, stack: 1, equip: true, hotbar: 0 },
    ],
    skills: {
      [SkillType.Swords]: 35,
      [SkillType.Axes]: 35,
      [SkillType.Bows]: 35,
      [SkillType.Jump]: 35,
      [SkillType.Run]: 35,
      [SkillType.Blocking]: 35,
      [SkillType.Sneak]: 35,
      [SkillType.Swim]: 35,
      [SkillType.Spears]: 35,
      [SkillType.Pickaxes]: 35,
      [SkillType.WoodCutting]: 35,
      [SkillType.Knives]: 35,
      [SkillType.Polearms]: 35,
      [SkillType.Clubs]: 35,
      [SkillType.Unarmed]: 35,
    },
  },
  PlainsBoss: {
    items: [
      { item: 'SwordBlackmetal', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'ShieldBlackmetal', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldBlackmetalTower', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'BowDraugrFang', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorPaddedCuirass', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorPaddedGreaves', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetPadded', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeWolf', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'LoxPie', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'SerpentStew', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Bread', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'WolfJerky', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'BloodPudding', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowNeedle', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'ArrowFrost', quality: 1, stack: 200, equip: true, hotbar: 0 },
      { item: 'BattleaxeCrystal', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeIron', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearWolfFang', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'AtgeirBlackmetal', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'MaceNeedle', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'KnifeBlackMetal', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'AxeBlackMetal', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: {
      [SkillType.Swords]: 45,
      [SkillType.Axes]: 45,
      [SkillType.Bows]: 45,
      [SkillType.Jump]: 45,
      [SkillType.Run]: 45,
      [SkillType.Blocking]: 45,
      [SkillType.Sneak]: 45,
      [SkillType.Swim]: 45,
      [SkillType.Spears]: 45,
      [SkillType.Pickaxes]: 45,
      [SkillType.WoodCutting]: 45,
      [SkillType.Knives]: 45,
      [SkillType.Polearms]: 45,
      [SkillType.Clubs]: 45,
      [SkillType.Unarmed]: 45,
    },
  },
  Mistlands: {
    items: [
      { item: 'SwordBlackmetal', quality: 4, stack: 1, equip: true, hotbar: 1 },
      { item: 'ShieldBlackmetal', quality: 3, stack: 1, equip: true, hotbar: 2 },
      { item: 'ShieldBlackmetalTower', quality: 3, stack: 1, equip: true, hotbar: 2 },
      { item: 'Hammer', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 8 },
      { item: 'BowDraugrFang', quality: 4, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArmorPaddedCuirass', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorPaddedGreaves', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetPadded', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeWolf', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'LoxPie', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'SerpentStew', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Bread', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'BloodPudding', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'FishWraps', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'WolfJerky', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'ArrowSilver', quality: 1, stack: 100, equip: true, hotbar: 0 },
      { item: 'ArrowNeedle', quality: 1, stack: 100, equip: true, hotbar: 0 },
      { item: 'ArrowFrost', quality: 1, stack: 100, equip: true, hotbar: 0 },
      { item: 'ArrowPoison', quality: 1, stack: 100, equip: true, hotbar: 0 },
      { item: 'ArrowFire', quality: 1, stack: 100, equip: true, hotbar: 0 },
      { item: 'BattleaxeCrystal', quality: 4, stack: 1, equip: false, hotbar: 4 },
      { item: 'PickaxeIron', quality: 4, stack: 1, equip: false, hotbar: 6 },
      { item: 'SpearWolfFang', quality: 4, stack: 1, equip: false, hotbar: 5 },
      { item: 'Torch', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'AtgeirBlackmetal', quality: 4, stack: 1, equip: false, hotbar: 7 },
      { item: 'MaceNeedle', quality: 1, stack: 4, equip: false, hotbar: 7 },
      { item: 'KnifeBlackMetal', quality: 4, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  // 1: {
  //   items: [...],
  //   skills: { [SkillType.All]: 30 },
  // },
  MistlandsMage: {
    items: [
      { item: 'StaffFireball', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'StaffIceShards', quality: 1, stack: 1, equip: true, hotbar: 2 },
      { item: 'StaffShield', quality: 1, stack: 1, equip: true, hotbar: 3 },
      { item: 'StaffSkeleton', quality: 1, stack: 1, equip: true, hotbar: 4 },
      { item: 'SwordMistwalker', quality: 1, stack: 1, equip: true, hotbar: 5 },
      { item: 'KnifeSkollAndHati', quality: 1, stack: 1, equip: true, hotbar: 6 },
      { item: 'ArmorMageChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorMageLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetMage', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeFeather', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'YggdrasilPorridge', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MushroomOmelette', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'SeekerAspic', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Salad', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Demister', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'MisthareSupreme', quality: 1, stack: 10, equip: true, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  Fisherman: {
    items: [
      { item: 'FishingRod', quality: 1, stack: 1, equip: true, hotbar: 1 },
      { item: 'Fish1', quality: 1, stack: 5, equip: true, hotbar: 3 },
      { item: 'Fish2', quality: 1, stack: 5, equip: false, hotbar: 4 },
      { item: 'Fish3', quality: 1, stack: 5, equip: false, hotbar: 5 },
      { item: 'Fish4_cave', quality: 1, stack: 5, equip: false, hotbar: 6 },
      { item: 'Fish5', quality: 1, stack: 5, equip: false, hotbar: 7 },
      { item: 'Fish6', quality: 1, stack: 5, equip: false, hotbar: 8 },
      { item: 'Fish7', quality: 1, stack: 5, equip: false, hotbar: 0 },
      { item: 'Fish8', quality: 1, stack: 5, equip: false, hotbar: 0 },
      { item: 'Fish9', quality: 1, stack: 5, equip: false, hotbar: 0 },
      { item: 'Fish10', quality: 1, stack: 5, equip: false, hotbar: 0 },
      { item: 'Fish11', quality: 1, stack: 5, equip: false, hotbar: 0 },
      { item: 'Hammer', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'HelmetFenring', quality: 3, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorFenringLegs', quality: 3, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorFenringChest', quality: 3, stack: 1, equip: true, hotbar: 0 },
      { item: 'FishingBait', quality: 1, stack: 50, equip: true, hotbar: 0 },
      { item: 'FishingBaitForest', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitSwamp', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitOcean', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitPlains', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitMistlands', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitDeepNorth', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishingBaitAshlands', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'FishCooked', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Bread', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'BloodPudding', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Fish1', quality: 3, stack: 1, equip: false, hotbar: 0 },
      { item: 'Fish1', quality: 5, stack: 1, equip: false, hotbar: 0 },
      { item: 'Fish2', quality: 2, stack: 1, equip: false, hotbar: 0 },
      { item: 'Fish5', quality: 4, stack: 1, equip: false, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 40 },
  },
  MistlandsWarrior: {
    items: [
      { item: 'SwordMistwalker', quality: 1, stack: 1, equip: false, hotbar: 1 },
      { item: 'THSwordKrom', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'SpearCarapace', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'SledgeDemolisher', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'KnifeSkollAndHati', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'AxeJotunBane', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'AtgeirHimminAfl', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'ShieldCarapace', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'ShieldCarapaceBuckler', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'BowSpineSnap', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'CrossbowArbalest', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'ArrowCarapace', quality: 1, stack: 100, equip: false, hotbar: 0 },
      { item: 'BoltCarapace', quality: 1, stack: 100, equip: false, hotbar: 0 },
      { item: 'PickaxeBlackMetal', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'Hammer', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'Hoe', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'HelmetCarapace', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorCarapaceChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorCarapaceLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeFeather', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'DvergrKey', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'Demister', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'MisthareSupreme', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeatPlatter', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'Salad', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'MeadHealthMajor', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadStaminaLingering', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadPoisonResist', quality: 1, stack: 10, equip: true, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  Ashlands: {
    items: [
      { item: 'AxeBerzerkr', quality: 1, stack: 1, equip: false, hotbar: 1 },
      { item: 'SwordNiedhogg', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'THSwordSlayer', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'MaceEldner', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'ArmorFlametalChest', quality: 1, stack: 1, equip: true, hotbar: 5 },
      { item: 'ArmorFlametalLegs', quality: 1, stack: 1, equip: true, hotbar: 6 },
      { item: 'HelmetFlametal', quality: 1, stack: 1, equip: true, hotbar: 7 },
      { item: 'MeatPlatter', quality: 1, stack: 10, equip: true, hotbar: 1 },
      { item: 'Salad', quality: 1, stack: 10, equip: false, hotbar: 1 },
      { item: 'HoneyGlazedChicken', quality: 1, stack: 10, equip: false, hotbar: 1 },
      { item: 'MeadStaminaLingering', quality: 1, stack: 10, equip: true, hotbar: 1 },
      { item: 'MeadHealthMajor', quality: 1, stack: 10, equip: true, hotbar: 1 },
      { item: 'ArmorMageChest_Ashlands', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'ArmorMageLegs_Ashlands', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'HelmetMage_Ashlands', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'SwordNiedhoggBlood', quality: 1, stack: 1, equip: true, hotbar: -1 },
      { item: 'SwordNiedhoggLightning', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'SwordNiedhoggNature', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'MaceEldnerBlood', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'MaceEldnerLightning', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'MaceEldnerNature', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'THSwordSlayerBlood', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'THSwordSlayerLightning', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'THSwordSlayerNature', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'AxeBerzerkrBlood', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'AxeBerzerkrLightning', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'AxeBerzerkrNature', quality: 1, stack: 1, equip: false, hotbar: -1 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  AshlandsFood: {
    items: [
      { item: 'Fiddleheadfern', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'SpicyMarmalade', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'ScorchingMedley', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'RoastedCrustPieUncooked', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'RoastedCrustPie', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'AsksvinMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'CookedAsksvinMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'VoltureMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'CookedVoltureMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'BoneMawSerpentMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'CookedBoneMawSerpentMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'FierySvinstew', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'MashedMeat', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'PiquantPie', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'PiquantPieUncooked', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'SparklingShroomshake', quality: 0, stack: 10, equip: false, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  AshlandsMage: {
    items: [
      { item: 'HelmetMage_Ashlands', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorMageChest_Ashlands', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorMageLegs_Ashlands', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'StaffFireball', quality: 1, stack: 1, equip: false, hotbar: 1 },
      { item: 'StaffIceShards', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'StaffShield', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'StaffSkeleton', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'StaffClusterbomb', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'StaffLightning', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'StaffGreenRoots', quality: 1, stack: 1, equip: false, hotbar: 8 },
      { item: 'StaffRedTroll', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'SizzlingBerryBroth', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'SparklingShroomshake', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'RoastedCrustPie', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadEitrLingering', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadStaminaLingering', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadHealthMajor', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'BombLava', quality: 1, stack: 50, equip: false, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  AshlandsMedium: {
    items: [
      { item: 'HelmetAshlandsMediumHood', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorAshlandsMediumChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorAshlandsMediumLegs', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeAsksvin', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CrossbowRipper', quality: 1, stack: 1, equip: false, hotbar: 1 },
      { item: 'CrossbowRipperLightning', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'BowAshlands', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'MaceEldnerNature', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'AxeBerzerkrBlood', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'RoastedCrustPie', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'ScorchingMedley', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'PiquantPie', quality: 0, stack: 10, equip: false, hotbar: 0 },
      { item: 'MeadStaminaLingering', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadHealthMajor', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'BombLava', quality: 1, stack: 50, equip: false, hotbar: 0 },
      { item: 'BoltCharred', quality: 1, stack: 200, equip: false, hotbar: 0 },
      { item: 'ArrowCharred', quality: 1, stack: 200, equip: false, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  AshlandsWarrior: {
    items: [
      { item: 'SwordNiedhoggBlood', quality: 1, stack: 1, equip: false, hotbar: 1 },
      { item: 'ShieldFlametal', quality: 1, stack: 1, equip: false, hotbar: 2 },
      { item: 'ShieldFlametalTower', quality: 1, stack: 1, equip: false, hotbar: 3 },
      { item: 'BowAshlands', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'THSwordSlayerLightning', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'Hammer', quality: 1, stack: 1, equip: false, hotbar: 6 },
      { item: 'CrossbowRipper', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'BoltCharred', quality: 0, stack: 200, equip: false, hotbar: 0 },
      { item: 'ArrowCharred', quality: 0, stack: 200, equip: false, hotbar: 0 },
      { item: 'MeadStaminaLingering', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadHealthMajor', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'PiquantPie', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'MashedMeat', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'RoastedCrustPie', quality: 0, stack: 10, equip: true, hotbar: 0 },
      { item: 'PickaxeBlackMetal', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'ArmorFlametalChest', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'HelmetFlametal', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'CapeAsh', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'BombLava', quality: 1, stack: 50, equip: false, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  AshlandsWeapons: {
    items: [
      { item: 'SwordNiedhogg', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'SwordNiedhoggBlood', quality: 1, stack: 1, equip: true, hotbar: 0 },
      { item: 'SwordNiedhoggLightning', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'SwordNiedhoggNature', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'THSwordSlayer', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'THSwordSlayerBlood', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'THSwordSlayerLightning', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'THSwordSlayerNature', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'MaceEldner', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'MaceEldnerBlood', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'MaceEldnerLightning', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'MaceEldnerNature', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'AxeBerzerkr', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'AxeBerzerkrBlood', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'AxeBerzerkrLightning', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'AxeBerzerkrNature', quality: 1, stack: 1, equip: false, hotbar: 0 },
      { item: 'SpearSplitner', quality: 1, stack: 1, equip: false, hotbar: 7 },
      { item: 'BowAshlands', quality: 1, stack: 1, equip: false, hotbar: 7 },
    ],
    skills: { [SkillType.All]: 30 },
  },
  Base: {
    items: [
      { item: 'Hammer', quality: 3, stack: 1, equip: true, hotbar: 1 },
      { item: 'Hoe', quality: 3, stack: 1, equip: true, hotbar: 2 },
      { item: 'Torch', quality: 3, stack: 1, equip: false, hotbar: 3 },
      { item: 'HelmetDverger', quality: 1, stack: 1, equip: false, hotbar: 4 },
      { item: 'CryptKey', quality: 1, stack: 1, equip: false, hotbar: -1 },
      { item: 'Demister', quality: 1, stack: 1, equip: false, hotbar: 5 },
      { item: 'FishAndBread', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'HoneyGlazedChickenUncooked', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'YggdrasilPorridge', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'SeekerAspic', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'MagicallyStuffedShroom', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'MushroomOmelette', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'Salad', quality: 1, stack: 10, equip: true, hotbar: -1 },
      { item: 'MisthareSupreme', quality: 1, stack: 10, equip: true, hotbar: -1 },
    ],
    skills: { [SkillType.All]: 70 },
  },
  Builder: {
    items: [
      { item: 'Hammer', quality: 3, stack: 1, equip: true, hotbar: 1 },
      { item: 'Hoe', quality: 3, stack: 1, equip: false, hotbar: 2 },
      { item: 'Cultivator', quality: 3, stack: 1, equip: false, hotbar: 3 },
      { item: 'PickaxeBlackMetal', quality: 4, stack: 1, equip: false, hotbar: 4 },
      { item: 'AxeJotunBane', quality: 4, stack: 1, equip: false, hotbar: 4 },
      { item: 'FishAndBread', quality: 1, stack: 10, equip: false, hotbar: 0 },
      { item: 'RoastedCrustPie', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'ScorchingMedley', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'SpicyMarmalade', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'MeadStaminaLingering', quality: 1, stack: 10, equip: true, hotbar: 0 },
      { item: 'HelmetFenring', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorFenringChest', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'ArmorFenringLegs', quality: 4, stack: 1, equip: true, hotbar: 0 },
      { item: 'BeltStrength', quality: 1, stack: 1, equip: true, hotbar: 0 },
    ],
    skills: { [SkillType.All]: 70 },
  }
};
